
(function () {

    'use strict';
    angular.module('app')
        .service('loginService',
            [
                '$http', function ($http) {

                    this.login = function (clientToken, email, password, googleAuthenticatorCode, secretQuestionAnswer, authenticatorRememberMe, clientId, redirectUrl, scope) {

                        return $http.post('api/authentication/login',
                            {
                                clientToken: clientToken,
                                email: email,
                                password: password,
                                GoogleAuthenticatorCode: googleAuthenticatorCode,
                                SecretQuestionAnswer: secretQuestionAnswer,
                                AuthenticatorRememberMe: authenticatorRememberMe,
                                clientId: clientId,
                                redirectUrl: redirectUrl,
                                scope: scope

                    })
                            .then(function(response) {
                                    return response.data;
                                },
                                function(response) {
                                    throw (response.data);
                                });
                    };

                    this.requestPassword = function(email, clientToken) {
                        return $http.post('api/authentication/passwordReset',
                                { email: email, clientToken: clientToken })
                            .then(function() {
                                    return;
                                },
                                function() {
                                    throw ('Password Reset Failure');
                                });
                    };
                    
                    this.logOut = function() {
                        return $http.post('api/authentication/logout')
                            .then(function() {

                                    window.location = './SSOLogout';

                                },
                                function() {
                                    throw ('Log Out Failure');
                                });
                    };
                }
            ]
        );
})();
